import { createModule } from 'saga-slice';
import { loadingReducer, failReducer } from 'saga-slice-helpers';
import { sagaApi } from '#/apis';
import { mapToId } from '#/meta';

const sagaSlice = createModule({

    name: 'departments',
    initialState: {
        isFetching: false,
        data: {},
        error: null
    },

    takers: 'takeLatest',

    reducers: {

        createDepartment: loadingReducer,
        createDepartmentSuccess: (state, payload) => {
            state.data[payload.id] = payload;
            state.isFetching = false;
        },

        getDepartments: loadingReducer,
        getDepartmentsSuccess: (state, payload) => {
            state.data = mapToId(payload);
            state.isFetching = false;
        },

        getDepartment: loadingReducer,
        getDepartmentSuccess: (state, payload) => {
            state.data = payload;
            state.isFetching = false;
        },

        updateDepartment: loadingReducer,
        updateDepartmentSuccess: (state, payload) => {
            state.data[payload.id] = {
                ...state.data[payload.id],
                ...payload
            };
            state.isFetching = false;
        },

        deleteDepartment: loadingReducer,
        deleteDepartmentSuccess: (state, payload) => {
            delete state.data[payload.id];
            state.isFetching = false;
        },

        fail: failReducer
    },


    sagas: A => ({

        [A.createDepartment]: function* ({ payload }) {
            yield sagaApi.post('/departments', payload, A.createDepartmentSuccess, A.fail);
        },

        [A.getDepartments]: function* () {
            yield sagaApi.get('/departments', A.getDepartmentsSuccess, A.fail);
        },

        [A.getDepartment]: function* ({ payload: department_id }) {
            yield sagaApi.get(`/departments/${department_id}`, A.getDepartmentSuccess, A.fail);
        },

        [A.updateDepartment]: function* ({ payload }) {
            const { department_id } = payload;
            delete payload.department_id;
            yield sagaApi.put(`/departments/${department_id}`, payload, A.getDepartmentSuccess, A.fail);
        },

        [A.deleteDepartment]: function* ({ payload: department_id }) {
            yield sagaApi.delete(`/departments/${department_id}`, null, A.deleteDepartmentSuccess, A.fail);
        }
    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
